import { Directive, Input, Output, EventEmitter } from '@angular/core';

@Directive({
    selector: '[repeat-done]',
    standalone: false
})
export class RepeatDoneDirective {
    @Output() onRepeatDone = new EventEmitter<void>();

    @Input('repeat-done')
    set repeatDone(done: boolean) {
        if (done) {
            this.onRepeatDone.emit();
        }
    }
}
